
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1gp1v_1aw9u_5",
  "action-button": "awsui_action-button_1gp1v_1aw9u_9",
  "inline-label": "awsui_inline-label_1gp1v_1aw9u_13",
  "controls-invalid": "awsui_controls-invalid_1gp1v_1aw9u_17",
  "controls-warning": "awsui_controls-warning_1gp1v_1aw9u_21"
};
  